// src/pages/HomePagex.jsx
import React from "react";
import "./MedievalHome.css";
import castleBg from "../assets/history2/Mystical_Site_Pictures_-_Wizard_riding_a_beautiful_horse_up_a_sheer_mountain_pass_topwards_a_looming_fantasy_library.png";
import scrollBg from "../assets/croppedscroll.png";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar />

      <div className="medieval-root">
        {/* HERO SECTION */}
        <section
          className="medieval-hero"
          style={{ backgroundImage: `url(${castleBg})` }}
        >
          <div className="hero-overlay">
            <h1 className="medieval-logo">
              Quizzards.AI<span className="trademark">™</span>
            </h1>
            <p className="medieval-tagline">
              Forge Your Mind.<br />Master Knowledge.<br />Compete. <br/> AI generated testing.
            </p>
            <div className="hero-buttons">
              <a href="/signup" className="medieval-btn gold">Sign Up</a>
              <a href="/signin" className="medieval-btn">Sign In</a>
              <a href="/blog" className="medieval-btn ghost">Dev Blog</a>
            </div>
          </div>
        </section>

        {/* ABOUT SECTION */}
        <section className="medieval-about-section">
          <div
            className="about-bg"
            style={{ backgroundImage: `url(${castleBg})` }}
          >
            <div className="about-scroll-layer">
              <img src={scrollBg} alt="scroll parchment" className="about-scroll-img" />
              <div className="about-overlay">
                <h2>About Quizzards</h2>
                <p>
                  Quizzards blends the art of the medieval with the power of modern AI, guiding learners of all ages on their journey to mastery.<br /><br />
                  <b>What makes Quizzards unique?</b>
                  <ul>
                    <li>🛡️ <b>Subject-based Learning:</b> Adventure through 10 topics and 57 sub topics, more than 5000 questions.</li>
                    <li>⚡ <b>Instant Feedback:</b> See results the moment you answer.</li>
                    <li>🏆 <b>Ranks & Rewards:</b> Climb the leaderboard, and challenge your friends.</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* TOPICS SECTION */}
        <section className="topics-section">
          <img
            src={require('../assets/history2/Historical_Topics_-_Renaissance_&_Reformation.png')}
            alt="Topics Background"
            className="topics-bg-img"
          />
          <div className="topics-overlay">
            <h2>Available Topics</h2>
            <div className="topics-list-simple">
              Ancient Era<br />
              Classical Antiquity<br />
              Middle Ages<br />
              Renaissance &amp; Reformation<br />
              Early Modern Period<br />
              Enlightenment &amp; Revolutions<br />
              19th Century<br />
              20th Century<br />
              Contemporary Period<br />
              History of Science &amp; Tech<br />
              More coming soon...
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
